import HttpHelper from './HttpHelper';
import React from 'react';

// const url = React.createContext("https://edicodetor-server.herokuapp.com");
// const url = React.createContext("http://localhost:5000");
// const url = React.createContext("https://edicodetorserver.web.app");
const url = React.createContext("https://edicodeserver.glitch.me");

class CompilerApi {
  static requestHeaders() {
    return { 'Content-Type': 'application/json'};
  }

  static run(code,lang,userinput) {
    if(lang==="c_cpp"){
      lang="c";
    }
    let obj;
    if(userinput===""){
      obj={code:code};
    }else{
      obj={code:code,stdin:userinput};
    }
    let api= url._currentValue+"/compiler/"+lang+"/run"
    return HttpHelper.fetch(
      api,
      'POST',
      'no-cors',
      this.requestHeaders(),
      JSON.stringify(obj),
    );
  }
  static submitBug(name,email,type,desc) {
    let obj={name:name,email:email,type:type,description:desc};
    // console.log(obj);
    let api= url._currentValue+"/compiler/bugs/add"
    return HttpHelper.fetch(
      api,
      'POST',
      'no-cors',
      this.requestHeaders(),
      JSON.stringify(obj),
    );
  }
}

export default CompilerApi;
